// Structure (Read 03) — the Structure-specific part of the Read: its six
// examples, copy and settings, gathered in STRUCTURE for the shared Read
// (sequence/SequenceRead). Everything else is shared with Momentum.
//
// The examples are QUSHi's approved lesson data, kept exactly as supplied
// (structureExamples.json). Each carries its own question and options; the
// answer is an option value.
import EXAMPLES from "./structureExamples.json";

export { EXAMPLES };

const optionsOf = (ex) => ex.options.map((o) => ({ id: o.value, label: o.label }));
const labelOf = (ex) => ex.options.find((o) => o.value === ex.answer).label;

export const STRUCTURE = {
  title: "Structure",
  revealMs: 700, // time between candles while the sequence builds, as Momentum
  // No divider, Earlier / Later groups, progress arrows or candle numbers
  // (client); swings are marked instead.
  numbers: false,
  orderStorageKey: "edge.structure.callItOrder",
  holdCompletion: false,
  examples: EXAMPLES,
  // PLACEHOLDER reward values, as Momentum. Display only.
  rewards: { completion: 50, firstAttemptBonus: 25 },
  teachOrder: ["up", "down"],
  answers: (ex) => (ex.options || []).map((o) => o.value),
  options: optionsOf,
  prompt: (ex) => [ex.question],
  // The option label is the Teach heading and the result line (client).
  heading: labelOf,
  readLine: labelOf,
  copy: {
    historical: "Real historical example",
    correct: "Correct",
    incorrect: "Not quite",
    yourAnswer: "Your answer",
  },
};
